import type { Item } from "../api";
import { daysUntilExpiry, getExpiryLevel } from "./dates";

export interface ManifestMetaParts {
    prefix: string;
    expiryText: string;
    expiryWarn: boolean;
}

export function formatManifestExpiry(expiryDate: string | null): {
    text: string;
    warn: boolean;
} {
    const days = daysUntilExpiry(expiryDate);
    const level = getExpiryLevel(expiryDate);
    const warn = level === "expired" || level === "critical" || level === "warning";

    if (days === null) return { text: "No expiry", warn: false };
    if (days < 0) return { text: `Expired ${Math.abs(days)} days ago`, warn: true };
    if (days === 0) return { text: "Expires today", warn: true };
    if (days === 1) return { text: "Expires tomorrow", warn: warn };
    return { text: `Expires in ${days} days`, warn };
}

export function formatManifestMetaParts(item: Item): ManifestMetaParts {
    const segments: string[] = [];
    if (item.brand) segments.push(item.brand);
    if (item.location_name) segments.push(item.location_name);

    const expiry = formatManifestExpiry(item.expiry_date);
    return {
        prefix: segments.join(" • "),
        expiryText: expiry.text,
        expiryWarn: expiry.warn,
    };
}
